export default {
  width: "300px",
};
